export default "__VITE_ASSET__CyhF7dh2__"